import React from 'react'
import { Row, Col, Space, Form, Input, Button, Select, TreeSelect, Spin } from 'antd'
import { reqRefExpSamples } from '../../../api'

import './dendrogram.css'
import './expressMap.css'

const { TextArea } = Input
const { Option } = Select

class RefExpression extends React.Component {
    state = {
        ref: '',
        samples_data: '',
        disabled: false,
        spinning: false,
    }

    formRef = React.createRef()

    onFinish = (values) => {
        this.setState({
            disabled: true,
            spinning: true,
        })

        let { geneids, ref, tissue, samples } = values
        geneids = geneids.replace(/[\r\n]/g, ",")
        let glist = geneids.split(',')
       
        const BatchGeneExpression = window.BatchGeneExpression
        BatchGeneExpression.cotton_dev_searchById('expression_heatmap', glist, samples, ()=>this.setState({disabled: false, spinning: false}), 'ref', ref)
    }

    onRefChange = async (val) => {
        this.setState({
            samples_data: ''
        })

        if (val) {
            const samples_res = await reqRefExpSamples(val)
            let samples_data = ''
            if (samples_res.code === 0) {
                samples_data = samples_res.data
            }

            this.setState({
                samples_data: samples_data
            })
        }
    }

    onReset = () => {
        this.formRef.current.resetFields()
    }

    async componentDidMount() {
        const { ref } = this.state
        const samples_res = await reqRefExpSamples(ref)
        let samples_data = ''
        if (samples_res.code === 0) {
            samples_data = samples_res.data
        }
        
        this.setState({
            samples_data: samples_data
        })
    }

    render() {
        const { ref, samples_data, disabled, spinning } = this.state

        const layout = {
            labelCol: { span: 3 },
            wrapperCol: { span: 6 },
            colon: false
        }

        const tailLayout = {
            wrapperCol: { offset: 3, span: 12 },
        }

        return (
            <React.Fragment>
                <Form {...layout} labelAlign="left" name="pop-expression" ref={this.formRef} className="pop-expression-form" onFinish={this.onFinish}>
                    <Form.Item name="geneids" label="Gene IDs" rules={[{ required: true }]} initialValue="" wrapperCol={{span: 20}}>
                        <TextArea rows={8} placeholder="Enter Gene IDs here, separate genes with comma or new line. Limited to 50 entries for better presentation."></TextArea>
                    </Form.Item>
                    <Form.Item name="ref" label="Select category" rules={[{ required: true }]} initialValue={ref}>
                        <Select showArrow allowClear onChange={this.onRefChange}>
                            <Option value=""></Option>
                            <Option value=""></Option>
                        </Select>
                    </Form.Item>
                    
                    <Form.Item name="samples" label="Select samples" rules={[{ required: true }]} wrapperCol={{span: 24}}>
                        <TreeSelect
                            style={{ width: '40%' }}
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            treeData={ samples_data }
                            placeholder="Please select samples"
                            onChange={this.onTreeSelectChange}
                            multiple
                            showSearch
                            treeCheckable={true}
                        />
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Row>
                    <Col span={24}>
                        <div className="expression-heatmap-spin"><Spin size="large" spinning={spinning} /></div>
                        <div id="expression_heatmap"></div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default RefExpression
